import * as moment from 'moment';

import { AccountType } from '../account-types.enum';
import { AccountDTO } from '../dto/account.dto';

export class Account {
  public static fromDto(account: AccountDTO): Account {
    let accountType: AccountType;
    if (
      account.type === AccountType.FREE_ACCOUNT ||
      account.type === AccountType.FREEACCOUNT
    ) {
      accountType = AccountType.FREEACCOUNT;
    } else {
      accountType = account.type as AccountType;
    }

    return new Account(
      moment(account.creationDate),
      moment(account.expirationDate),
      accountType,
      account.allowedNumberOfDevices,
      account.requiresPasswordReset,
      account.pastDue || false
    );
  }

  constructor(
    public creationDate: moment.Moment,
    public expirationDate: moment.Moment,
    public type: AccountType,
    public allowedNumberOfDevices: number,
    public requiresPasswordReset: boolean,
    public pastDue?: boolean
  ) {}

  public getPackageSize(): string {
    if (this.type === AccountType.FREE_ACCOUNT) {
      return 'Trial';
    } else if (this.type === AccountType.INTERNAL) {
      return 'Internal';
    }

    if (this.allowedNumberOfDevices === 1) {
      return 'Small';
    } else if (this.allowedNumberOfDevices === 3) {
      return 'Medium';
    } else {
      return 'Large';
    }
  }
}
